import React from 'react';
import moment from 'moment';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, ConfirmModal, Modal, DropdownSelector  } from 'hyperdb-utils';
import { GeneralFieldset, PricesFieldset, ConditionsFieldset, CalendarFieldset } from '../RentalRulesetEditor';

class RentalRulesetEditor extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDefaultConditions = this.handleChangeDefaultConditions.bind(this);
    this.handleChangeSeasonalConditions = this.handleChangeSeasonalConditions.bind(this);
    this.handleChangePropertyCapacity = this.handleChangePropertyCapacity.bind(this);
    this.handleSaveCapacity = this.handleSaveCapacity.bind(this);
    this.state = {};
  }
  render() {
    const property = this.props.property;
    const conditions = this.props.objectData.default_conditions || {};
    const defaultMinStay = conditions.min_stay;
    const seasonalConditions = this.props.objectData.seasonal_conditions || [];
    const conditionsData = { ...conditions, seasonal_conditions: seasonalConditions };
    return (
      <Tabs defaultActiveKey={1} id="prices-form">
        <Tab eventKey={1} title="General">
          <GeneralFieldset
            objectData={ this.props.objectData }
            onChange={ this.handleChange.bind(this, 'rental_rules') }
          />
        </Tab>
        <Tab eventKey={2} title="Prices">
          <PricesFieldset
            property={ property }
            objectData={ this.props.objectData }
            onChange={ this.handleChange.bind(this, 'prices') }
            toggleModalConflict={ this.handleToggleModalConflict.bind(this, 'seasonal_prices') }
            showModalConflict={ this.state.showModalConflictPricesSeasons }
            indexesSeasonsInConflict={ this.state.indexesSeasonsInConflict }
            onChangePropertyCapacity={ this.handleChangePropertyCapacity }
            onSavePropertyCapacity={ this.handleSaveCapacity }
            editedCapacity={ this.state.editedCapacity || {} }
            setSeasonalPriceSynchronisation={ this.setSeasonalDataSynchronisation.bind(this, 'seasonal_prices') }
            errorBasePrice={ this.props.errorBasePrice }
          />
        </Tab>
        <Tab eventKey={3} title="Conditions">
          <ConditionsFieldset
            property={ property }
            conditionsData={ conditionsData }
            onChangeDefaultConditions={ this.handleChangeDefaultConditions }
            onChangeSeasonalConditions={ this.handleChangeSeasonalConditions }
            toggleModalConflict={ this.handleToggleModalConflict.bind(this, 'seasonal_conditions') }
            showModalConflict={ this.state.showModalConflictConditionsSeasons }
            indexesSeasonsInConflict={ this.state.indexesSeasonsInConflict }
            setSeasonalConditionSynchronisation={ this.setSeasonalDataSynchronisation.bind(this, 'seasonal_conditions') }
          />
        </Tab>
        <Tab eventKey={4} title="Calendar">
          <CalendarFieldset
            property={ property }
            objectData={ this.props.objectData }
            prices={ this.props.objectData.seasonal_prices || [] }
            conditions={ conditionsData.seasonal_conditions || [] }
            onChange={ this.handleChange }
            toggleModalConflictPrices={ this.handleToggleModalConflict.bind(this, 'calendar_prices') }
            toggleModalConflictConditions={ this.handleToggleModalConflict.bind(this, 'calendar_conditions') }
            showModalConflictPrices={ this.state.showModalConflictPricesCalendar }
            showModalConflictConditions={ this.state.showModalConflictConditionsCalendar }
            indexesSeasonsInConflict={ this.state.indexesSeasonsInConflict }
            setSeasonalPriceSynchronisation={ this.setSeasonalDataSynchronisation.bind(this, 'seasonal_prices') }
            setSeasonalConditionSynchronisation={ this.setSeasonalDataSynchronisation.bind(this, 'seasonal_conditions') }
            onPricesAndConditionsChanged={ this.props.onPricesAndConditionsChanged || null }
          />
        </Tab>
      </Tabs>
    );
  }

  handleChange(type, attributeName, field) {
    this.props.onChange(attributeName, field);
    if ((type !== 'prices' && type !== 'seasonal_conditions') || (attributeName !== 'seasonal_prices' && attributeName !== 'seasonal_conditions')) {
      this.setSynchronisation(type, attributeName, field.value);
    }
  }
  handleChangeDefaultConditions(attributeName, field) {
    const { name, value } = field;
    const conditions = { ...this.props.objectData.default_conditions || {} };
    conditions[attributeName] = value;
    this.handleChange('static_conditions', 'default_conditions', { value: conditions });
  }
  handleChangeSeasonalConditions(field) {
    const { name, value } = field;
    this.handleChange('seasonal_conditions', 'seasonal_conditions', field);
  }

  setSeasonalDataSynchronisation(type, data) {
    const params = this.props.objectData.synchronisations && this.props.objectData.synchronisations[type]
      ? this.props.objectData.synchronisations[type].parameters.data
      : {};
    if (!params.date_start || moment(data.date_start).isBefore(params.date_start)) {
      params.date_start = data.date_start;
    }
    if (!params.date_end || moment(data.date_end).isAfter(params.date_end)) {
      params.date_end = data.date_end;
    }
    this.setSynchronisation(type, type, params);
  }
  setSynchronisation(type, attributeName, value) {
    const property = this.props.property;
    if (!property.source_channel_id.value[1]) {
      const synchronisations = { ...this.props.objectData.synchronisations || {} };
      if (attributeName === 'price_rules' && type === 'prices') type = 'static_prices';
      if (attributeName === 'default_price') type = 'static_prices';
      synchronisations[type] = { ...synchronisations[type] || {} };
      synchronisations[type].parameters = synchronisations[type].parameters || { action: 'push', data: {} };
      if (type === 'seasonal_conditions' || type === 'seasonal_prices') {
        synchronisations[type].parameters.data = value;
      } else if (type === 'static_prices') {
        if (attributeName === 'price_rules') {
          value = { paying_children: value.paying_children };
        }
        synchronisations[type].parameters.data = { ...synchronisations[type].parameters.data, ...value };
      } else {
        synchronisations[type].parameters.data[attributeName] = value;
      }
      this.props.onChange('synchronisations', { value: synchronisations });
    }
  }

  handleToggleModalConflict(type, bool, indexesSeasonsInConflict = null) {
    if (type === 'seasonal_prices') {
      this.setState({ showModalConflictPricesSeasons: bool, indexesSeasonsInConflict: bool ? indexesSeasonsInConflict : [] });
    } else if (type === 'seasonal_conditions') {
      this.setState({ showModalConflictConditionsSeasons: bool, indexesSeasonsInConflict: bool ? indexesSeasonsInConflict : [] });
    } else if (type === 'calendar_prices') {
      this.setState({ showModalConflictPricesCalendar: bool, indexesSeasonsInConflict: bool ? indexesSeasonsInConflict : [] });
    } else if (type === 'calendar_conditions') {
      this.setState({ showModalConflictConditionsCalendar: bool, indexesSeasonsInConflict: bool ? indexesSeasonsInConflict : [] });
    }
  }

  handleChangePropertyCapacity(type, field) {
    const editedCapacity = { ...this.state.editedCapacity, [type]: field.value };
    this.setState({ editedCapacity });
  }
  handleSaveCapacity() {
    const editedCapacity = { ...this.state.editedCapacity };
    this.setState({ editedCapacity: {} });
    this.props.onChangePropertyFields('standard_capacity', { value: editedCapacity.standard_capacity });
    this.props.onChangePropertyFields('maximum_capacity', { value: editedCapacity.maximum_capacity });
  }
}

export default RentalRulesetEditor;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/RentalRulesetEditor.jsx